$(document).ready(function() {

  videoPlayerInicialization();
 $(".Scrolling__Banner").marquee({ speed: 32, gap: 10, delayBeforeStart: 0, direction: "left", duplicated: !0, startVisible: 1 });
});





function videoPlayerInicialization(){
  if($('.wrapper_click--video').length > 0){
    $( ".wrapper_click--video" ).each(function( index ) {



      var options = JSON.parse($('.video-js', this).attr('data-section-settings'));
      var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ? true : false;
      const isDesktopScreenSize = new Responsive().matchesBreakpoint("lap-and-up");

      let img_plh = "";
      let aspect_ratio = "";
      let src = "";
      let controls = "";

      if(isMobile || !isDesktopScreenSize) {
        if(options['control_var']){src = options["videom"];}else{src = options["videom"]["sources"][1]['url'];}
        img_plh = options['plh_mob'];

        aspect_ratio = options['aspect_mob'] || "9:16";

      } else {
        if(options['control_var']){src = options["videod"];}else{src = options["videod"]["sources"][1]['url'];}
        img_plh = options['plh_desk'];
        
        aspect_ratio = options['aspect_desk'] || "16:9";
      }

var shp = options['plh'];

if (shp){  var payload =
        {
          aspectRatio: aspect_ratio,
          autoplay: options['autoplay'],
          muted: options['muted'],
          loop: options['loop'],
          controls: options['controls'],
          poster: img_plh,
          preload: "auto",
          playsinline: true,
          responsive: true,

          disablePictureInPicture: true,
          controlBar: {
            playToggle: true,
            captionsButton: false,
            chaptersButton: false,
            subtitlesButton: false,
            remainingTimeDisplay: false,
            pictureInPictureToggle: false,
            volumeControl: false,
            progressControl: {
              seekBar: false
            },
            fullscreenToggle: false,
            playbackRateMenuButton: false,
          },
          sources: [{
            type: "video/mp4",
            src: src
          }]

        }}
        else{
          var payload =
                {
                  aspectRatio: aspect_ratio,
                  autoplay: options['autoplay'],
                  muted: options['muted'],
                  loop: options['loop'],
                  controls: options['controls'],
                  preload: "metadata",
                  playsinline: true,
                  responsive: true,

                  disablePictureInPicture: true,
                  controlBar: {
                    playToggle: true,
                    captionsButton: false,
                    chaptersButton: false,
                    subtitlesButton: false,
                    remainingTimeDisplay: false,
                    pictureInPictureToggle: false,
                    volumeControl: false,
                    progressControl: {
                      seekBar: false
                    },
                    fullscreenToggle: false,
                    playbackRateMenuButton: false,
                  },
                  sources: [{
                    type: "video/mp4",
                    src: src
                  }]

                }
        }

      var videoplayerID = 'my-player-'+options['id'];

      const myPlayer = videojs(videoplayerID, payload);
      console.log(myPlayer);
      
      if( options['viewport']){
        waitforviewport(options['pause']);
      }$(this).closest('.ImageHero--teaser').show(); });
    toggleVideo();

  }
}

function toggleVideo(){

  $('.wrapper_click--video').on('click', function(){
var sph = $(this).attr('data-plh');
    var id = $(this).attr('data-id');
    var videoplayerID = 'my-player-'+id;
    var myPlayer = videojs(videoplayerID);




if(myPlayer.paused()) { myPlayer.play();
                       if(sph == "true"){$('.vjs-poster', this).css("display", "none");}
                      }else{myPlayer.pause(); if(sph == "true"){$('.vjs-poster', this).css("display", "inline-block");} $(this).attr('data-pause',true) }

  });

  $('#banner-section .vjs-poster').each(function() {
    $(this).attr('preload', 'auto');
  });

}

// function waitforviewport(pauseifout){

//   var viewportHeight = $(window).height();
//   $(window).on('scroll', function() {

//     $('.wrapper_click--video').each((index, el) => {
//       const id = $(el).attr('data-id');
//       var customID = "my-player-"+id;

//       var myPlayer = videojs(customID);

//       var inner = $("#"+customID);

//       var innerH = inner.outerHeight();
//       innerH = innerH * 0.5;

//       var elementPosTop = inner.position().top - innerH;
//       if(elementPosTop < 0){
//          elementPosTop = inner.closest('.shopify-section').position().top - innerH;
//       }

//       var elementPosBot = elementPosTop + inner.outerHeight() - 100;
//       var scrollPos = $(window).scrollTop();
//       var elementFromTop = elementPosTop - scrollPos;
//       var manual = $(el).attr('data-pause');

//       if (elementFromTop > 0 && elementFromTop < elementPosTop + viewportHeight || elementPosBot  < scrollPos  && pauseifout) {
//         myPlayer.pause(); $('.'+customID+' .vjs-poster').css("display", "inline-block");

//       } else {

//         if (!manual){
//           myPlayer.play();
//           $('.'+customID+' .vjs-poster').css("display", "none");
//         }   }

//     })

//   });


// }

function waitforviewport(pauseifout) {
  const options = {
    root: null, // Ovo označava viewport
    rootMargin: '0px',
    threshold: 0.5 // Pokreće se kada je 50% elementa u viewportu
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      const id = $(entry.target).attr('data-id');
      const customID = "my-player-" + id;
      const myPlayer = videojs(customID);

      if (entry.isIntersecting) {
        // Element je u viewportu
        const manual = $(entry.target).attr('data-pause');
        if (!manual) {
          myPlayer.play();
          $('.' + customID + ' .vjs-poster').css("display", "none");
        }
      } else {
        // Element nije u viewportu
        if (pauseifout) {
          myPlayer.pause();
          $('.' + customID + ' .vjs-poster').css("display", "inline-block");
        }
      }
    });
  }, options);

  // Dodajemo sve elemente koje želimo da pratimo
  $('.wrapper_click--video').each((index, el) => {
    observer.observe(el);
  });
}
